/**
 * "Kimsin?" bölümünün içeriği.
 *
 * Buradaki her madde uygulamada GERÇEKTEN var olan bir sayfadır; başlıklar
 * Sidebar.tsx'teki menü adlarıyla, ikon ve renkler de menüdeki çipin aynısıyla
 * eşleşiyor — ziyaretçi girişten sonra tıklayacağı şeyin aynısını burada görüyor.
 * Yeni bir özellik yazarken önce src/App.tsx'te rotasının olduğunu doğrulayın.
 */
export type RoleKey = 'ogrenci' | 'ogretmen' | 'veli';

export interface RoleFeature {
  title: string;
  text: string;
  /** public/sidebar-icons altındaki dosya adı (Sidebar.tsx ile aynı set). */
  icon: string;
  /** Menüdeki çipin rengi. */
  color: string;
}

export interface RoleInfo {
  key: RoleKey;
  tab: string;
  lead: string;
  image: string;
  alt: string;
  features: RoleFeature[];
}

export const ROLES: RoleInfo[] = [
  {
    key: 'ogrenci',
    tab: 'Öğrenci',
    lead: 'Çalışmanın tamamı tek ekranda.',
    image: '/a-mascot4.png',
    alt: 'Maskot robot, elindeki kalemle tabletine bir şeyler yazıyor.',
    features: [
      {
        title: 'Kütüphanem',
        text: 'Dijital kitaplarını aç, testlerini çöz, soru çözüm videolarını izle.',
        icon: 'kutuphanem',
        color: '#00c6af',
      },
      {
        title: 'Ödevlerim',
        text: 'Öğretmeninin verdiği test ve dosya ödevlerini son tarihleriyle gör, teslim et.',
        icon: 'odevlerim',
        color: '#f87aff',
      },
      {
        title: 'Çalışma Planım',
        text: 'Günlük ve haftalık hedefler koy, programını hafta hafta takip et.',
        icon: 'calisma-planim',
        color: '#6497d2',
      },
      {
        title: 'Performansım',
        text: 'Doğru-yanlış oranını, en iyi ve en zayıf konularını gör.',
        icon: 'performansim',
        color: '#ffda09',
      },
    ],
  },
  {
    key: 'ogretmen',
    tab: 'Öğretmen',
    lead: 'Sınıfını ve ödevlerini tek yerden yönet.',
    image: '/a-mascot5.png',
    alt: 'Maskot robot, elindeki işaret çubuğunu çenesine dayamış düşünüyor.',
    features: [
      {
        title: 'Sınıflarım',
        text: 'Sınıflarını ve öğrencilerini gör, öğrenciyi koduyla sınıfına ekle.',
        icon: 'siniflarim',
        color: '#3973bf',
      },
      {
        title: 'Ödevler',
        text: 'Test ya da dosya ödevi ver; teslimleri ve ödev performansını izle.',
        icon: 'odevlerim',
        color: '#f87aff',
      },
      {
        title: 'Öğrenci Çalışma Planı',
        text: 'Öğrenciye ya da sınıfa hedef ata, öğrencinin haftalık programını gör.',
        icon: 'calisma-planim',
        color: '#6497d2',
      },
      {
        title: 'Randevularım',
        text: 'Öğrenci ve velilerle görüşme randevusu oluştur.',
        icon: 'randevularim',
        color: '#6d399a',
      },
    ],
  },
  {
    key: 'veli',
    tab: 'Veli',
    lead: 'Çocuğunu yakından izle. Birden fazla çocuğun varsa hepsi aynı hesapta.',
    image: '/a-mascot2.png',
    alt: 'Maskot robot, ekranında grafikler olan bir tableti tutuyor ve gülümsüyor.',
    features: [
      {
        title: 'Öğrenci Performansı',
        text: 'Doğru-yanlış oranını, ödev özetini ve en zayıf konuları gör.',
        icon: 'performansim',
        color: '#f5d316',
      },
      {
        title: 'Öğrenci Programı',
        text: 'Çocuğunun haftalık çalışma planını ve ilerlemesini gör.',
        icon: 'calisma-planim',
        color: '#6497d2',
      },
      {
        title: 'Öğrenci Ödevleri',
        text: 'Ödevlerin durumunu, teslim tarihlerini ve öğretmenin notunu gör.',
        icon: 'odevlerim',
        color: '#f87aff',
      },
      {
        title: 'Randevularım',
        text: 'Öğretmenlerle randevu al; gelen randevu isteklerini onayla ya da reddet.',
        icon: 'randevularim',
        color: '#6d399a',
      },
    ],
  },
];
